import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { DrilldownFormsService } from '../../services/drilldown-forms.service';
import { CommonService } from '../../services/common.service';
import { Config } from 'src/app/config';

@Component({
  selector: 'cross-page-intervention-renderer',
  templateUrl: './cross-page-intervention-renderer.component.html',
  styleUrls: ['./cross-page-intervention-renderer.component.scss'],
})
export class CrossPageInterventionRendererComponent implements OnInit {
  customSaveButton = {
    name: 'SAVE CURRENT PROGRESS',
    translatedName: this.cService.readyTranslations.form.saveCurrentProgress
      ? this.cService.readyTranslations.form.saveCurrentProgress
      : '',
    matIcon: 'save',
  };
  customPrintButton = {
    name: 'PRINT',
    translatedName: this.cService.readyTranslations.generic.print ? this.cService.readyTranslations.generic.print : '',
    matIcon: 'print',
    iconOnly: true,
  };

  environment = { vrmFormsLanguageAssetCdnRoot: Config.vrmFormsLanguageAssetCdnRoot };

  @Output() triggerSave: EventEmitter<any> = new EventEmitter();
  @Output() triggerMarkFormAsComplete: EventEmitter<any> = new EventEmitter();

  @ViewChild('vrmInterventionHeader', { static: false })
  vrmInterventionHeader: ElementRef<HTMLInputElement>;

  constructor(public dfService: DrilldownFormsService, public cService: CommonService) {}

  ngOnInit() {
    if (!this.cService.isPcViewport) {
      this.toggleFormPaneWidth();
    }

    if (!this.cService.isLargePcViewport) {
      this.dfService.widenForm = true;
    }
  }

  toggleFormPaneWidth() {
    if (this.dfService.showFormPane) {
      this.dfService.widenForm = !this.dfService.widenForm;
    } else {
      this.dfService.widenForm = false;
    }
  }

  emitSave(event: any) {
    this.triggerSave.emit(event);
  }

  emitComplete(event: any) {
    this.triggerMarkFormAsComplete.emit(event);
  }
}
